<template>
  <div class="virtual-draw-element">
    <div class="banner-container">
      <img
        class="banner-won"
        src="../images/banner-won.png"
      >
      <div
        v-if="logoPicUrl"
        class="sport-logo-container"
      >
        <img
          :src="logoPicUrl"
          class="sport-logo"
        >
      </div>
    </div>

    <div class="winning-main">
      <div class="title">
        MSport Virtual Sport
      </div>

      <div class="total-winning">
        + {{ $t('CURRENCY') }} {{ totalWinnings }}
      </div>
    </div>
  </div>
</template>

<script>
// virtual 中奖弹窗绘图元素

export default {
  name: 'DrawElement',
  props: {
    totalWinnings: {
      type: String,
      default: ''
    },
    logoPicUrl: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.virtual-draw-element {
  overflow: hidden;
  width: 326px;
  height: 420px;

  .banner-container {
    position: relative;
    overflow: hidden;
    width: 326px;
    height: 274px;

    .banner-won {
      display: block;
      width: 100%;
      height: 100%;
    }

    .sport-logo-container {
      position: absolute;
      top: 35px;
      left: 50%;
      width: 106px;
      height: 106px;
      box-sizing: border-box;
      margin-left: -53px;
      text-align: center;

      .sport-logo {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        width: 100%;
        height: 100%;
        margin-top: -53px;
        margin-left: -53px;
      }
    }
  }

  .winning-main {
    padding: 22px 0 38px;
    background: #f8f8f8;
    text-align: center;

    .title {
      margin-bottom: 22px;
      color: #333;
      font-size: 20px;
      line-height: 24px;
    }

    .total-winning {
      color: #ff751a;
      font-size: 34px;
      font-weight: bold;
      line-height: 40px;
    }
  }
}
</style>
